// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yi6h","content":"styles_content__1Lobo","row":"styles_row__OMKtM","footer":"styles_footer__3Fw0T","phraseLength":"styles_phraseLength__2EMB6"};